import Btn from '../utils/btn';

const func = $target => {

    var $btn = new Btn($target.find('button[type="submit"]')),
        $invisalignCheckbox = $('.custom-control-input');

    // $invisalignCheckbox.click(function () {
    //     if (this.checked) {
    //         $(this).parent().parent().parent('.card-body').find('.form-control-file').removeAttr('required')
    //     } else {
    //         $(this).parent().parent().parent('.card-body').find('.form-control-file').prop('required', true);
    //     }
    // })

    $('.chooseFile').click(function () {
        $(this).parent().find('#triggerType').click();
    })

    $target.find('.text-muted').html('optional');

    $('.deleteFile').click(function () {
        const _this = $(this);
        var $projectRef = $target.find('input[name="projectRef"]').val(),
            $productId = $target.find('input[name="productId"]').val(),
            $assetId = _this.data("value");

        $.ajax({
            url: '/actions/dsd/products/delete-upload',
            type: 'post',
            dataType: 'json',
            headers: {
                "X-CSRF-Token": window.csrfTokenValue,
            },
            data: { projectRef : $projectRef,
                    productId : $productId,
                    assetId : $assetId,
                    nr : 'nrFiles'}
        }).done(function(data) {
            _this.parent().find('a').text('')
            _this.addClass('d-none')
        });
    })

    $(".form-control-file").change(function () {
        var input = this,
            $this = $(this),
            totalSize = 0;

        if (input.files && input.files[0]) {
            var reader = new FileReader();
            $(this).parent().find('.text-up-lower').text(this.files[0].name)
            reader.onload = function (e) {
                console.log(e.target, '----e.target')
                // $this.closest('.card').find('.static-img').addClass('d-none');
                $this.closest('.card').find('.uploaded-img').removeClass('d-none');
                $this.closest('.card').find('[data-id="image-preview"]').attr('src', e.target.result).height(144).removeClass('d-none');
                $this.closest('.card').find('.custom-checkbox').remove()
            }

            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }

        $(".form-control-file").each(function () {
            for (var i = 0; i < this.files.length; i++) {
                totalSize += this.files[i].size;
            }
        });

        console.log(totalSize);
        
        var valid = totalSize <= 262144000; //250mb limit

        if (!valid) {
            console.log('too big');
            $target.find('[data-id="upload-error-message"]').removeClass('d-none');
            $btn.disable();
        } else {
            $target.find('[data-id="upload-error-message"]').addClass('d-none');
            $btn.enable();
        }

    });

    $target.on('submit', function (e) {
        $target.find('[data-id="upload-message"]').removeClass('d-none');
        $btn.text('Uploading');
    });

    window.loader.keys(['plupload'], function () {

        console.log('plupload loaded');

        $(".uploader").each(function () {

            var $this = $(this),
                fileType = $this.data('filetype'),
                mimeTypes = [
                    {title: "Image files", extensions: "jpg,jpeg,gif,png"},
                    {title: "Zip files", extensions: "zip"},
                    {title: "Rar files", extensions: "rar"},
                    {title: "Video files", extensions: "mov,mpeg,mp4,m4a,m4v,mpc,mpg"},
                    {title: "STL files", extensions: "stl"},
                    {title: "PDF files", extensions: "pdf"},
                    {title: "Powerpoint files", extensions: "ppt,pptx"},
                    {title: "Spreadsheet files", extensions: "csv,xls,xlsx"},
                    {title: "Word files", extensions: "doc,docx"},
                ];

            var uploader = $this.pluploadQueue({
                // General settings
                runtimes: 'html5',
                url: "/actions/dsd/products/upload-files",

                chunk_size: '5mb',
                // rename : true,
                dragdrop: true,
                filters: {
                    // Maximum file size
                    max_file_size: '5000mb',
                    // Specify what files to browse for
                    mime_types: mimeTypes,
                },
                headers: {
                    "X-CSRF-Token": window.csrfTokenValue,
                },
                multipart_params: {
                    'projectRef': $target.find("[name='projectRef']").val(),
                    'productId': $target.find("[name='productId']").val(),
                    'redirect': $target.data('redirect'),
                    'filetype': fileType,
                },
                max_retries: 3,
                multiple_queues: true,
                init: {
                    PostInit: function () {

                        console.log(fileType);

                        var $pluploadContainer = $('.plupload'),
                            $footer = $pluploadContainer.find('.plupload_filelist_footer');

                        $pluploadContainer.find('.plupload_header').hide();

                        $pluploadContainer.find('.plupload_content').addClass('card font-size-85');
                        $pluploadContainer.find('.plupload_filelist_header').addClass('card-header');

                        $footer.addClass('card-footer');

                        $footer.find('.plupload_add').addClass('btn btn-primary mr-2 mb-2 mb-lg-0');
                        $footer.find('.plupload_add').html('Add Additional Files');
                        $footer.find('.plupload_start').addClass('btn btn-outline mb-2 mr-2 mb-lg-0');
                        $footer.find('.plupload_file_status, .plupload_file_size').addClass('float-none float-lg-right text-left text-lg-right');
                        $footer.find('.plupload_progress').addClass('float-none float-00000lg-right');

                    },
                    BeforeUpload: function (uploader, file) {
                        var params = uploader.settings.multipart_params;
                        params.filesize = file.size;

                        console.log(file.size);
                    }
                }
            });
        });
    });

};

export default func;